import { assertInInjectionContext, inject, Injector } from '@angular/core';

/**
 * @reference https://nartc.me/blog/inject-function-the-right-way/
 */
export function assertInjector(
    fn: Parameters<typeof assertInInjectionContext>[0],
    injector?: Injector
): Injector {
    // we only call assertInInjectionContext if there is no custom injector
    if (!injector) {
        assertInInjectionContext(fn);
    }
    // we return the custom injector OR try get the default Injector
    return injector ?? inject(Injector);
}
